export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
export const LOGISTICS_URL = process.env.REACT_APP_LOGISTICS_URL;
export const LIBRARIES_URL = process.env.REACT_APP_LIBRARIES_URL;
export const SINTEGRA_HOMO: boolean =
    process.env.REACT_APP_SINTEGRA_HOMO === '1';
export const ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL;
